const initialState = () => ({
  data: {},
  error: null,
  loading: false,
  alertMessage: ''
});

const ACTION_KEY = 'PROFESSIONAL_PRESCRIPTOR';

const reducer = (state = initialState(), action) => {
  switch (action.type) {
    case `${ACTION_KEY}_PENDING`: {
      return {
        ...state,
        loading: true,
        error: null
      };
    }
    case `${ACTION_KEY}_REJECTED`: {
      return {
        ...state,
        loading: false,
        error: action.payload
      };
    }
    case `${ACTION_KEY}_FULFILLED`: {
      const [data, alertMessage] = action.payload;

      return {
        ...state,
        loading: false,
        data,
        alertMessage
      };
    }
    case `${ACTION_KEY}_RESET`: {
      return initialState();
    }
    default:
      return state;
  }
};

export default reducer;
